import { useState, useEffect } from 'react';
import moment from 'moment';
import timezoneMoment from 'moment-timezone';

export const lengthToDays = (lengthEnum) => {
  switch (lengthEnum) {
    case 'oneMonth':
      return 30;
    case 'twoMonth':
      return 60;
    case 'threeMonth':
      return 90;
    default:
      return lengthEnum;
  }
};

export const workoutToMin = (lengthEnum) => {
  switch (lengthEnum) {
    case 'halfHour':
      return '30';
    case 'oneHourOrLess':
      return '45-60';
    default:
      return '60-90';
  }
};

export const create_UUID = () => {
  let dt = Date.now();

  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });

  return uuid;
};

export const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export const checkTzDST = (timezone) => {
  if (!timezone) return false;
  const m = timezoneMoment().tz(timezone);
  return m.isDST();
};

/*
  @args
  time - 12:00
  timezone - Europe/Berlin
*/
export const calculateLocalTimeRelevantToTimezone = (time, timezone = 'Asia/Jerusalem') => {
  let arrivingGMT = timezoneMoment().tz(timezone).utcOffset();
  let localGMT = timezoneMoment().utcOffset();
  if (checkTzDST(timezone)) {
    arrivingGMT--;
  }
  if (checkTzDST(timezoneMoment.tz.guess())) {
    localGMT--;
  }
  const hourDiff = (localGMT - arrivingGMT) / 60;
  const today = moment().format('YYYY-MM-DD');

  return moment(`${today} ${time}`).add(hourDiff, 'h').format('HH:mm');
};
